import { Alert, Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import StyledSection from '../../components/styles/StyledSection';
import { StyledHeading } from '../../components/styles/styles';
import ChatOAuthDialog from './Settings/ChatOAuthDialog';
import CrossDeviceTab from './Settings/CrossDeviceTab';
import NotificationSubscriptionsTab from './Settings/NotificationSubscriptionsTab';
import SupportTab from './Settings/SupportTab';
import { useAdminSettingsPage } from './Settings/useAdminSettingsPage';

const SettingsPage: React.FC = () => {
  const {
    activeTab,
    setActiveTab,
    successMessage,
    setSuccessMessage,
    loadError,
    setLoadError,
    chatOAuthDialog,
    setChatOAuthDialog,
    chatAlertsSectionRef,
    subscriptions,
    chat,
    supportAvailable,
  } = useAdminSettingsPage();

  return (
    <>
      <StyledSection noSidePaddingFrom="xs" noTopPadding={true}>
        <StyledHeading sx={{ px: { xs: '1.875rem', lg: 0 } }}>Settings</StyledHeading>
        <StyledSection tone="tone1">
          {successMessage && (
            <Alert severity="success" onClose={() => setSuccessMessage(null)} sx={{ mb: 3 }}>
              {successMessage}
            </Alert>
          )}

          {loadError && (
            <Alert severity="error" onClose={() => setLoadError(null)} sx={{ mb: 3 }}>
              {loadError}
            </Alert>
          )}

          <Box>
            <Tabs
              value={activeTab}
              onChange={(_, v) => setActiveTab(v)}
              sx={{
                mb: 2,
                '& .MuiTab-root.Mui-selected': {
                  color: Palette.default.buttonBg,
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: Palette.default.buttonBg,
                },
              }}
            >
              <Tab label="Notification Subscriptions" />
              <Tab label="Cross-Device Login" />
              {supportAvailable && <Tab label="Support" />}
            </Tabs>
            {activeTab === 0 ? (
              <NotificationSubscriptionsTab
                loading={subscriptions.loading}
                saving={subscriptions.saving}
                events={subscriptions.events}
                hasChanges={subscriptions.hasChanges}
                chatAlertsSectionRef={chatAlertsSectionRef}
                onToggle={subscriptions.handleToggle}
                onSave={subscriptions.handleSave}
                chat={chat}
              />
            ) : activeTab === 1 ? (
              <CrossDeviceTab />
            ) : (
              <SupportTab />
            )}
          </Box>
        </StyledSection>
      </StyledSection>

      <ChatOAuthDialog dialog={chatOAuthDialog} onClose={() => setChatOAuthDialog(null)} />
    </>
  );
};

export default SettingsPage;
